import React from "react";
import PropTypes from "prop-types";

/**
 * Icons that can easily be reused in all the project
 */
const InfoIcon = ({ size, color, marginRight, ...props }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 14 14"
    xmlSpace="preserve"
    width={`${size}`}
    height={`${size}`}
    style={{ marginRight }}
    {...props}
  >
    <path
      d="M14 7C14 8.27604 13.6719 9.44271 13.0521 10.5C12.4323 11.5573 11.5573 12.4323 10.5 13.0521C9.44271 13.6719 8.27604 14 7 14C5.72396 14 4.55729 13.6719 3.5 13.0521C2.44271 12.4323 1.56771 11.5573 0.947917 10.5C0.328125 9.44271 0 8.27604 0 7C0 5.72396 0.328125 4.55729 0.947917 3.5C1.56771 2.44271 2.44271 1.56771 3.5 0.947917C4.55729 0.328125 5.72396 0 7 0C8.27604 0 9.44271 0.328125 10.5 0.947917C11.5573 1.56771 12.4323 2.44271 13.0521 3.5C13.6719 4.55729 14 5.72396 14 7ZM9.55208 3.53646C9.55208 3.20833 9.44271 2.91667 9.1875 2.66146C8.93229 2.40625 8.64062 2.29687 8.3125 2.29687C7.98437 2.29687 7.69271 2.40625 7.4375 2.66146C7.18229 2.91667 7.07292 3.20833 7.07292 3.53646C7.07292 3.86458 7.18229 4.15625 7.4375 4.41146C7.69271 4.66667 7.98437 4.77604 8.3125 4.77604C8.64062 4.77604 8.93229 4.66667 9.1875 4.41146C9.44271 4.15625 9.55208 3.86458 9.55208 3.53646ZM8.27604 10.1354V10.026C8.27604 9.95312 8.23958 9.88021 8.20312 9.84375C8.13021 9.80729 8.05729 9.77083 7.98437 9.77083C7.80208 9.95312 7.54687 10.1719 7.21875 10.3906C6.89062 10.6094 6.67187 10.7187 6.5625 10.7187C6.52604 10.7187 6.48958 10.6823 6.48958 10.6458C6.48958 10.6094 6.48958 10.5365 6.52604 10.5L8.09375 6.74479C8.20312 6.38021 8.27604 6.16146 8.27604 6.08854C8.27604 5.90625 8.20312 5.76042 8.05729 5.61458C7.91146 5.50521 7.76562 5.43229 7.58333 5.43229C7.18229 5.43229 6.67187 5.61458 6.05208 5.94271C5.43229 6.27083 4.92187 6.70833 4.52083 7.18229V7.21875C4.52083 7.29167 4.55729 7.36458 4.59375 7.40104C4.63021 7.47396 4.70312 7.51042 4.77604 7.54687C4.92187 7.40104 5.14062 7.21875 5.46875 7C5.79687 6.78125 6.01562 6.67187 6.125 6.67187C6.19792 6.67187 6.19792 6.74479 6.16146 6.89062L4.59375 10.6823C4.48437 10.9375 4.41146 11.1562 4.41146 11.3385C4.41146 11.4479 4.48437 11.5573 4.63021 11.7031C4.77604 11.849 4.92187 11.9219 5.10417 11.9219C5.65104 11.9219 6.23437 11.7396 6.85417 11.3385C7.47396 10.974 7.94792 10.5729 8.27604 10.1354Z"
      fill={color}
    />
  </svg>
);

InfoIcon.propTypes = {
  /**
   * What background color to use
   */
  color: PropTypes.string,
  /**
   * How large should the icon be?
   */
  size: PropTypes.number,
  /**
   * Margin at the right of the icon
   */
  marginRight: PropTypes.number
};

InfoIcon.defaultProps = {
  color: "#ffffff",
  size: 20,
  marginRight: 0
};

export default InfoIcon;
